import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import API, { fmt } from '../utils/api';
import Pagination from '../components/Pagination';

const SHIPMENT_STATUS = {
  pending: 'قيد التجهيز',
  shipped: 'تم الشحن',
  in_transit: 'في الطريق',
  arrived: 'وصل',
  delivered: 'تم التسليم',
};
const STATUS_COLOR = {
  pending: 'badge-warning',
  shipped: 'badge-primary',
  in_transit: 'badge-info',
  arrived: 'badge-success',
  delivered: 'badge-gray',
};

/* ══════════════════════════════════════════
   طباعة Packing List
══════════════════════════════════════════ */
async function printPackingList(orderId) {
  try {
    const r = await API.get('/orders/' + orderId + '/packing-list');
    const { order, items, totals } = r.data;
    const win = window.open('', '_blank', 'width=900,height=700');
    const _d = new Date();
    const today = String(_d.getDate()).padStart(2,'0') + '/' + String(_d.getMonth()+1).padStart(2,'0') + '/' + _d.getFullYear();
    const fmtN = (n) => parseFloat(n||0).toFixed(2);

    const rows = items.map(function(item) {
      return '<tr>' +
        '<td>' + (item.hs_code||'33030010') + '</td>' +
        '<td>' + (item.brand||'') + '</td>' +
        '<td>' + (item.product_type||item.product_name||'') + '</td>' +
        '<td class="center">' + item.qty + '</td>' +
        '<td class="center">' + (item.pieces_per_carton||'-') + '</td>' +
        '<td class="center">' + item.cartons + '</td>' +
        '<td class="center">' + fmtN(item.net_weight) + '</td>' +
        '<td class="center">' + fmtN(item.gross_weight) + '</td>' +
        '<td class="center">' + (item.carton_dimensions||'-') + '</td>' +
        '</tr>';
    }).join('');

    const css = '*{margin:0;padding:0;box-sizing:border-box}body{font-family:Arial,sans-serif;font-size:11px;color:#111;padding:20px}' +
      'h2{font-size:1.1rem;color:#c0392b;margin-bottom:4px}.info-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:8px;margin:10px 0}' +
      '.info-box{background:#f8f9fb;border-radius:6px;padding:8px 10px;border:1px solid #e5e7eb}.info-box label{font-size:0.7rem;color:#888;display:block}' +
      '.info-box strong{font-size:0.88rem}table{width:100%;border-collapse:collapse;margin-top:10px}thead{background:#c0392b;color:#fff}' +
      'th{padding:7px 6px;text-align:right;font-size:10px}td{padding:5px 6px;border-bottom:1px solid #f0f0f0;font-size:10px}' +
      'tr:nth-child(even) td{background:#fafafa}.center{text-align:center}.tfoot td{background:#f0f0f0;font-weight:700;padding:6px}' +
      '.footer{margin-top:16px;display:flex;justify-content:space-between}.sign-box{text-align:center}' +
      '.sign-line{width:140px;border-top:1px solid #999;margin:30px auto 4px}.sign-box p{font-size:0.72rem;color:#666}' +
      '@media print{@page{margin:1cm;size:A4}body{padding:8px}}';

    win.document.write('<!DOCTYPE html><html lang="en"><head><meta charset="utf-8"/><title>Packing List - ' + order.order_number + '</title><style>' + css + '</style></head><body>' +
      '<div style="display:flex;justify-content:space-between;align-items:flex-start;border-bottom:3px solid #c0392b;padding-bottom:10px;margin-bottom:12px">' +
      '<div><img src="/logo.png" style="height:50px;object-fit:contain" /></div>' +
      '<div style="text-align:center"><h2>PACKING LIST</h2><div style="font-size:10px;color:#666">' + order.order_number + '</div></div>' +
      '<div style="text-align:right;font-size:10px"><div><strong>Date:</strong> ' + today + '</div></div>' +
      '</div>' +
      '<div class="info-grid">' +
      '<div class="info-box"><label>Customer</label><strong>' + (order.customer_name||'-') + '</strong></div>' +
      '<div class="info-box"><label>Country</label><strong>' + (order.customer_country||'-') + '</strong></div>' +
      '<div class="info-box"><label>Order No.</label><strong>' + order.order_number + '</strong></div>' +
      '<div class="info-box"><label>Total QTY</label><strong>' + totals.total_qty + ' pcs</strong></div>' +
      '<div class="info-box"><label>Total Cartons</label><strong>' + totals.total_cartons + '</strong></div>' +
      '<div class="info-box"><label>Gross Weight</label><strong>' + fmtN(totals.total_gross_weight) + ' kg</strong></div>' +
      '</div>' +
      '<table><thead><tr>' +
      '<th>H.S Code</th><th>Brand</th><th>Description</th><th class="center">QTY</th>' +
      '<th class="center">Pcs/Ctn</th><th class="center">Cartons</th>' +
      '<th class="center">Net W. (kg)</th><th class="center">Gross W. (kg)</th><th class="center">Dimensions (cm)</th>' +
      '</tr></thead><tbody>' + rows + '</tbody>' +
      '<tfoot><tr class="tfoot">' +
      '<td colspan="3">TOTAL</td>' +
      '<td class="center">' + totals.total_qty + '</td>' +
      '<td></td>' +
      '<td class="center">' + totals.total_cartons + '</td>' +
      '<td class="center">' + fmtN(totals.total_net_weight) + '</td>' +
      '<td class="center">' + fmtN(totals.total_gross_weight) + '</td>' +
      '<td></td>' +
      '</tr></tfoot></table>' +
      '<div class="footer">' +
      '<div class="sign-box"><div class="sign-line"></div><p>Prepared by</p></div>' +
      '<div class="sign-box"><div class="sign-line"></div><p>Checked by</p></div>' +
      '<div class="sign-box"><div class="sign-line"></div><p>Approved by</p></div>' +
      '</div></body></html>');
    win.document.close();
    setTimeout(function(){ win.focus(); win.print(); }, 700);
  } catch(e) {
    alert('حدث خطأ أثناء تحميل Packing List');
  }
}

/* ══════════════════════════════════════════
   مودال إنشاء شحنة
══════════════════════════════════════════ */
function NewShipmentModal({ onClose, onSaved }) {
  const [customers, setCustomers] = useState([]);
  const [orders, setOrders] = useState([]);
  const [orderItems, setOrderItems] = useState([]);
  const [form, setForm] = useState({
    customer_id: '', order_id: '', carrier: '', tracking_number: '',
    shipping_date: '', estimated_arrival: '', bl_number: '', notes: ''
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    API.get('/customers').then(r => setCustomers(r.data));
    API.get('/orders').then(r => setOrders(r.data.filter(o => o.status !== 'cancelled')));
  }, []);

  useEffect(() => {
    if (form.order_id) {
      API.get('/orders/' + form.order_id + '/packing-list').then(r => {
        setOrderItems(r.data.items.map(i => ({ ...i, selected: true })));
        if (!form.customer_id) {
          const order = orders.find(o => o.id === +form.order_id);
          if (order) setForm(f => ({ ...f, customer_id: String(order.customer_id) }));
        }
      }).catch(() => setOrderItems([]));
    } else {
      setOrderItems([]);
    }
  }, [form.order_id]);

  const save = async () => {
    setError('');
    if (!form.customer_id) return setError('يرجى اختيار العميل');
    setSaving(true);
    try {
      const items = orderItems.filter(i => i.selected).map(i => ({
        order_id: form.order_id ? +form.order_id : null,
        finished_product_id: i.finished_product_id,
        quantity: i.qty,
      }));
      await API.post('/shipments', { ...form, customer_id: +form.customer_id, order_id: form.order_id ? +form.order_id : null, items });
      onSaved();
      onClose();
    } catch(e) {
      setError(e.response?.data?.error || 'حدث خطأ');
    } finally { setSaving(false); }
  };

  const filteredOrders = form.customer_id
    ? orders.filter(o => o.customer_id === +form.customer_id)
    : orders;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 620 }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <span className="modal-title">🚢 شحنة جديدة</span>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          {error && <div className="alert alert-danger" style={{ marginBottom: 12 }}>{error}</div>}

          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">العميل *</label>
              <select className="form-control" value={form.customer_id}
                onChange={e => setForm({ ...form, customer_id: e.target.value, order_id: '' })}>
                <option value="">— اختر العميل —</option>
                {customers.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">الطلبية (اختياري)</label>
              <select className="form-control" value={form.order_id}
                onChange={e => setForm({ ...form, order_id: e.target.value })}>
                <option value="">— بدون طلبية —</option>
                {filteredOrders.map(o => <option key={o.id} value={o.id}>{o.order_number} — {o.customer_name}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">شركة الشحن</label>
              <input className="form-control" value={form.carrier} onChange={e => setForm({ ...form, carrier: e.target.value })} placeholder="DHL, Maersk..." />
            </div>
            <div className="form-group">
              <label className="form-label">رقم التتبع</label>
              <input className="form-control" value={form.tracking_number} onChange={e => setForm({ ...form, tracking_number: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="form-label">رقم B/L</label>
              <input className="form-control" value={form.bl_number} onChange={e => setForm({ ...form, bl_number: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="form-label">تاريخ الشحن</label>
              <input type="date" className="form-control" value={form.shipping_date} onChange={e => setForm({ ...form, shipping_date: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="form-label">تاريخ الوصول المتوقع</label>
              <input type="date" className="form-control" value={form.estimated_arrival} onChange={e => setForm({ ...form, estimated_arrival: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="form-label">ملاحظات</label>
              <textarea className="form-control" rows={2} value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} />
            </div>
          </div>

          {/* بنود الطلبية */}
          {orderItems.length > 0 && (
            <div style={{ marginTop: 12 }}>
              <div style={{ fontWeight: 700, fontSize: '0.85rem', marginBottom: 8 }}>📦 منتجات الطلبية</div>
              <div className="table-scroll">
                <table style={{ fontSize: '0.82rem' }}>
                  <thead>
                    <tr>
                      <th style={{ width: 30 }}></th>
                      <th>المنتج</th>
                      <th style={{ textAlign: 'center' }}>الكمية</th>
                      <th style={{ textAlign: 'center' }}>كراتين</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orderItems.map((item, i) => (
                      <tr key={i}>
                        <td>
                          <input type="checkbox" checked={item.selected}
                            onChange={e => { const arr = [...orderItems]; arr[i] = { ...arr[i], selected: e.target.checked }; setOrderItems(arr); }} />
                        </td>
                        <td>{item.brand} {item.product_type || item.product_name}</td>
                        <td style={{ textAlign: 'center' }}>{item.qty}</td>
                        <td style={{ textAlign: 'center' }}>{item.cartons}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
        <div className="modal-footer">
          <button className="btn btn-primary" onClick={save} disabled={saving}>
            {saving ? 'جاري الحفظ...' : '💾 إنشاء الشحنة'}
          </button>
          <button className="btn btn-secondary" onClick={onClose}>إلغاء</button>
        </div>
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════
   مودال تفاصيل الشحنة
══════════════════════════════════════════ */
function ShipmentDetailModal({ shipmentId, onClose, onSaved }) {
  const { user } = useAuth();
  const canEdit = ['admin','sales_manager'].includes(user?.role);
  const [shipment, setShipment] = useState(null);
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    API.get('/shipments/' + shipmentId).then(r => {
      setShipment(r.data);
      setForm({
        status: r.data.status,
        carrier: r.data.carrier || '',
        tracking_number: r.data.tracking_number || '',
        bl_number: r.data.bl_number || '',
        shipping_date: r.data.shipping_date || '',
        estimated_arrival: r.data.estimated_arrival || '',
        actual_arrival: r.data.actual_arrival || '',
        notes: r.data.notes || '',
      });
    });
  }, [shipmentId]);

  const save = async () => {
    setSaving(true);
    try {
      await API.put('/shipments/' + shipmentId, form);
      onSaved();
      setEditing(false);
      API.get('/shipments/' + shipmentId).then(r => setShipment(r.data));
    } catch(e) { alert(e.response?.data?.error || 'حدث خطأ'); }
    finally { setSaving(false); }
  };

  if (!shipment) return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 600 }} onClick={e => e.stopPropagation()}>
        <div className="loading"><div className="spinner" /></div>
      </div>
    </div>
  );

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 620 }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <span className="modal-title">🚢 {shipment.shipment_number}</span>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          {!editing ? (
            <>
              <div className="form-grid mb-2">
                <div><span className="text-muted">العميل: </span><strong>{shipment.customer_name}</strong></div>
                <div><span className="text-muted">الطلبية: </span><strong>{shipment.order_number || '-'}</strong></div>
                <div><span className="text-muted">الحالة: </span><span className={`badge ${STATUS_COLOR[shipment.status]}`}>{SHIPMENT_STATUS[shipment.status]}</span></div>
                <div><span className="text-muted">شركة الشحن: </span><strong>{shipment.carrier || '-'}</strong></div>
                <div><span className="text-muted">رقم التتبع: </span><strong>{shipment.tracking_number || '-'}</strong></div>
                <div><span className="text-muted">رقم B/L: </span><strong>{shipment.bl_number || '-'}</strong></div>
                <div><span className="text-muted">تاريخ الشحن: </span><strong>{fmt.date(shipment.shipping_date) || '-'}</strong></div>
                <div><span className="text-muted">الوصول المتوقع: </span><strong>{fmt.date(shipment.estimated_arrival) || '-'}</strong></div>
                <div><span className="text-muted">الوصول الفعلي: </span><strong>{fmt.date(shipment.actual_arrival) || '-'}</strong></div>
              </div>
              {shipment.notes && <div style={{ background: '#f8f9fb', borderRadius: 8, padding: '8px 12px', fontSize: '0.85rem' }}>{shipment.notes}</div>}

              {/* بنود الشحنة */}
              {shipment.items?.length > 0 && (
                <div style={{ marginTop: 12 }}>
                  <div style={{ fontWeight: 700, fontSize: '0.85rem', marginBottom: 8 }}>📦 المنتجات</div>
                  <table style={{ fontSize: '0.82rem' }}>
                    <thead>
                      <tr>
                        <th>المنتج</th>
                        <th style={{ textAlign: 'center' }}>الكمية</th>
                        <th style={{ textAlign: 'center' }}>كراتين</th>
                        <th style={{ textAlign: 'center' }}>وزن إجمالي</th>
                      </tr>
                    </thead>
                    <tbody>
                      {shipment.items.map(item => {
                        const ppc = item.pieces_per_carton || 1;
                        const cartons = Math.ceil(item.quantity / ppc);
                        const gross = (item.carton_gross_weight_kg || 0) * cartons;
                        return (
                          <tr key={item.id}>
                            <td>{item.brand} {item.product_type || item.product_name}</td>
                            <td style={{ textAlign: 'center' }}>{item.quantity}</td>
                            <td style={{ textAlign: 'center' }}>{cartons}</td>
                            <td style={{ textAlign: 'center' }}>{gross.toFixed(2)} kg</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </>
          ) : (
            <div className="form-grid">
              <div className="form-group">
                <label className="form-label">الحالة</label>
                <select className="form-control" value={form.status} onChange={e => setForm({ ...form, status: e.target.value })}>
                  {Object.entries(SHIPMENT_STATUS).map(([k,v]) => <option key={k} value={k}>{v}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">شركة الشحن</label>
                <input className="form-control" value={form.carrier} onChange={e => setForm({ ...form, carrier: e.target.value })} />
              </div>
              <div className="form-group">
                <label className="form-label">رقم التتبع</label>
                <input className="form-control" value={form.tracking_number} onChange={e => setForm({ ...form, tracking_number: e.target.value })} />
              </div>
              <div className="form-group">
                <label className="form-label">رقم B/L</label>
                <input className="form-control" value={form.bl_number} onChange={e => setForm({ ...form, bl_number: e.target.value })} />
              </div>
              <div className="form-group">
                <label className="form-label">تاريخ الشحن</label>
                <input type="date" className="form-control" value={form.shipping_date} onChange={e => setForm({ ...form, shipping_date: e.target.value })} />
              </div>
              <div className="form-group">
                <label className="form-label">الوصول المتوقع</label>
                <input type="date" className="form-control" value={form.estimated_arrival} onChange={e => setForm({ ...form, estimated_arrival: e.target.value })} />
              </div>
              <div className="form-group">
                <label className="form-label">الوصول الفعلي</label>
                <input type="date" className="form-control" value={form.actual_arrival} onChange={e => setForm({ ...form, actual_arrival: e.target.value })} />
              </div>
              <div className="form-group">
                <label className="form-label">ملاحظات</label>
                <textarea className="form-control" rows={2} value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} />
              </div>
            </div>
          )}
        </div>
        <div className="modal-footer">
          {!editing ? (
            <>
              {shipment.order_id && (
                <button className="btn btn-secondary btn-sm" onClick={() => printPackingList(shipment.order_id)}>📦 Packing List</button>
              )}
              {canEdit && <button className="btn btn-primary btn-sm" onClick={() => setEditing(true)}>✏️ تعديل</button>}
            </>
          ) : (
            <>
              <button className="btn btn-primary" onClick={save} disabled={saving}>{saving ? '...' : '💾 حفظ'}</button>
              <button className="btn btn-secondary" onClick={() => setEditing(false)}>إلغاء</button>
            </>
          )}
          <button className="btn btn-secondary" onClick={onClose}>إغلاق</button>
        </div>
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════
   الصفحة الرئيسية
══════════════════════════════════════════ */
export default function Shipments() {
  const { user } = useAuth();
  const [shipments, setShipments] = useState([]);
  const [orders, setOrders] = useState([]);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [showNew, setShowNew] = useState(false);
  const [detailId, setDetailId] = useState(null);
  const [page, setPage] = useState(1);
  const PER_PAGE = 50;

  const load = () => {
    API.get('/shipments').then(r => setShipments(r.data));
    API.get('/orders').then(r => setOrders(r.data.filter(o => o.status !== 'cancelled')));
  };

  useEffect(() => { load(); }, []);

  const deleteShipment = async (s) => {
    if (!window.confirm('حذف الشحنة ' + s.shipment_number + '؟')) return;
    try { await API.delete('/shipments/' + s.id); load(); }
    catch(e) { alert(e.response?.data?.error || 'حدث خطأ'); }
  };

  const filtered = shipments.filter(s =>
    (!statusFilter || s.status === statusFilter) &&
    ((s.shipment_number||'').includes(search) ||
     (s.customer_name||'').includes(search) ||
     (s.tracking_number||'').includes(search))
  );
  const pagedShipments = filtered.slice((page-1)*PER_PAGE, page*PER_PAGE);
  useEffect(() => { setPage(1); }, [search, statusFilter]);

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">🚢 الشحنات</h1>
        <button className="btn btn-primary" onClick={() => setShowNew(true)}>+ شحنة جديدة</button>
      </div>

      {/* فلاتر */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 16, flexWrap: 'wrap' }}>
        <input className="search-input" style={{ flex: 1, minWidth: 200 }}
          placeholder="🔍 بحث برقم الشحنة أو العميل أو التتبع..."
          value={search} onChange={e => setSearch(e.target.value)} />
        <select className="form-control" style={{ width: 160 }}
          value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
          <option value="">كل الحالات</option>
          {Object.entries(SHIPMENT_STATUS).map(([k,v]) => <option key={k} value={k}>{v}</option>)}
        </select>
      </div>

      {/* Packing List سريع من الطلبيات */}
      <div style={{ background: 'var(--primary-light)', borderRadius: 10, padding: '12px 16px', marginBottom: 16 }}>
        <div style={{ fontWeight: 700, fontSize: '0.85rem', marginBottom: 8, color: 'var(--primary)' }}>📦 Packing List سريع من طلبية</div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {orders.slice(0, 10).map(o => (
            <button key={o.id} className="btn btn-sm btn-secondary"
              onClick={() => printPackingList(o.id)}
              title={o.customer_name}>
              📦 {o.order_number}
            </button>
          ))}
          {orders.length === 0 && <span className="text-muted" style={{ fontSize: '0.82rem' }}>لا توجد طلبيات</span>}
        </div>
      </div>

      {/* جدول الشحنات */}
      <div className="table-container">
        <div className="table-scroll">
          <table>
            <thead>
              <tr>
                <th>رقم الشحنة</th>
                <th>العميل</th>
                <th>الطلبية</th>
                <th>شركة الشحن</th>
                <th>رقم B/L</th>
                <th>تاريخ الشحن</th>
                <th>الوصول المتوقع</th>
                <th>الحالة</th>
                <th>إجراءات</th>
              </tr>
            </thead>
            <tbody>
              {pagedShipments.map(s => (
                <tr key={s.id}>
                  <td>
                    <span style={{ cursor: 'pointer', color: 'var(--primary)', fontWeight: 700 }}
                      onClick={() => setDetailId(s.id)}>
                      {s.shipment_number}
                    </span>
                  </td>
                  <td className="font-bold">{s.customer_name}</td>
                  <td className="text-muted">{s.order_number || '-'}</td>
                  <td className="text-muted">{s.carrier || '-'}</td>
                  <td className="text-muted">{s.bl_number || '-'}</td>
                  <td className="text-muted">{fmt.date(s.shipping_date) || '-'}</td>
                  <td style={{ color: s.estimated_arrival && new Date(s.estimated_arrival) < new Date() && s.status !== 'delivered' ? 'var(--danger)' : undefined }}>
                    {fmt.date(s.estimated_arrival) || '-'}
                  </td>
                  <td><span className={`badge ${STATUS_COLOR[s.status]}`}>{SHIPMENT_STATUS[s.status]}</span></td>
                  <td>
                    <div className="td-actions">
                      <button className="btn btn-sm btn-secondary" onClick={() => setDetailId(s.id)}>عرض</button>
                      {s.order_id && (
                        <button className="btn btn-sm btn-secondary" title="Packing List" onClick={() => printPackingList(s.order_id)}>📦</button>
                      )}
                      {user?.role === 'admin' && (
                        <button className="btn btn-sm btn-danger" onClick={() => deleteShipment(s)}>🗑️</button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
              {filtered.length === 0 && (
                <tr><td colSpan={9}>
                  <div className="empty-state"><div className="empty-state-icon">🚢</div><p>لا توجد شحنات</p></div>
                </td></tr>
              )}
            </tbody>
          </table>
        </div>
        <Pagination page={page} total={filtered.length} perPage={PER_PAGE} onPage={setPage} />
      </div>

      {showNew && <NewShipmentModal onClose={() => setShowNew(false)} onSaved={load} />}
      {detailId && <ShipmentDetailModal shipmentId={detailId} onClose={() => setDetailId(null)} onSaved={load} />}
    </div>
  );
}
